import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectToolTipDisabledPipe, XsI18nPipe } from '@nx-fe/pipes';
import {
  TicketService,
  UserContextService,
  XSi18nService,
  TicketContextService as XSightTicketContextService,
} from '@nx-fe/services';
import { DeviceModule } from '../devices/devices.module';
import { TicketNotFoundComponent } from './components/not-found/not-found.component';
import { TicketContentComponent } from './components/ticket-content/ticket-content.component';
import { TicketPageComponent } from './components/ticket-page/ticket-page.component';
import { TicketDetailsDescriptionComponent } from './components/ticket-details-description/ticket-details-description.component';
import { MatSelectBackdropClickHandlerDirective } from './directives/sa-mat-select-backdropclickhandler.directive';
import { MatSelectSizeFixDirective } from './directives/sa-mat-select-size-fix.directive';
import { UpdatingTimeModule } from '@nx-fe/updating-time';
import { RcDeviceService } from 'xsmodules/remote-control/services/rc-device-service';
import { AttachmentService } from 'xsmodules/ticket/services/attachment.service';
import { SharedComponentsModule } from 'sspapp/shared/shared-components.module';
import { XsightModule } from '../externalModules/xsight.modules';
import { LocalAttachmentActivityComponent } from './components/attachment-activity/local-attachment-activity/local-attachment-activity.component';
import { AttachmentService as sspAttachmentService } from './components/services/attachmentService';
import { TicketCardComponent } from './components/ticket-card/ticket-card.component';
import { TicketHeaderComponent } from './components/ticket-header/ticket-header.component';
import { TicketListComponent } from './components/ticket-list/ticket-list.component';
import { TicketContextService } from './services/ticket-context.service';
import { SearchAndPickV2Component } from 'modules/search-and-pick/components/search-and-pick/search-and-pick.component';
import { DeviceContextService, PageTitleService } from '@nx-fe/services';
import { DashboardPageService } from 'app/modules/dashboard/dashboard-page.service';
import { RemoteControlUserPreferencesService } from 'app/modules/remote-control/remote-control-view/remote-control-user-preferences/remote-control-user-preferences.service';
import { FileManagerService } from 'app/modules/remote-control/services/file-manager.service';
import { RemoteControlTabService } from 'app/modules/remote-control/services/rc-tab.service';
import { ZoomControllerService } from 'app/modules/remote-control/services/zoom-controller.service';
import { EmailActivityService } from 'app/modules/ticket/services/email.service';
import { TicketPageService } from 'app/modules/ticket/ticket-page.service';
import { TicketSearchService } from 'app/services/ticket-search.service';
import { ShortDateFormatPipe } from 'app/shared/pipes/time-format.pipe';
import { OutboundEmailSettingsService } from 'xsmodules/settings/components/email-settings/outbound-email-settings/outbound-email-settings.service';
import { QuillModule } from 'ngx-quill';
import { SearchAndPickModule } from 'modules/search-and-pick/search-and-pick.module';
import { SharedTicketModule } from 'xsmodules/ticket/shared-ticket.module';
import { CoreModule } from 'sspapp/core/core.module';
import { SharedComponentsModule as XSSharedComponentsModule } from 'app/shared/shared-components.module';
import { InsightModule } from '../externalModules/insight.module';

@NgModule({
  declarations: [
    TicketPageComponent,
    TicketNotFoundComponent,
    TicketContentComponent,
    TicketListComponent,
    TicketCardComponent,
    TicketDetailsDescriptionComponent,
    TicketHeaderComponent,
    LocalAttachmentActivityComponent,
    MatSelectSizeFixDirective,
    MatSelectBackdropClickHandlerDirective,
  ],
  imports: [
    CommonModule,
    SharedComponentsModule,
    XSSharedComponentsModule,
    DeviceModule,
    TranslateModule,
    BrowserModule,
    MatPaginatorModule,
    UpdatingTimeModule,
    TextFieldModule,
    XsightModule,
    InsightModule,
    QuillModule.forRoot(),
    SearchAndPickModule,
    SharedTicketModule,
    CoreModule,
  ],
  providers: [
    XSi18nService,
    XsI18nPipe,
    MatSelectToolTipDisabledPipe,
    DatePipe,
    TicketContextService,
    XSightTicketContextService,
    TicketService,
    DecimalPipe,
    sspAttachmentService,
    UserContextService,
    AttachmentService,
    RcDeviceService,
    EmailActivityService,
    PageTitleService,
    RemoteControlTabService,
    ZoomControllerService,
    RemoteControlUserPreferencesService,
    FileManagerService,
    ShortDateFormatPipe,
    OutboundEmailSettingsService,
    TicketPageService,
    DeviceContextService,
    DashboardPageService,
    TicketSearchService,
  ],
  bootstrap: [],
  exports: [TicketPageComponent, TicketNotFoundComponent, TicketContentComponent, UpdatingTimeModule],
})
export class TicketModule {}
